<template>
  <el-dialog
      title="企业信息校验"
      width="500px"
      :close-on-click-modal="false"
      :visible.sync="visible">
    <div class="">
      <el-form :model="formData" :rules="rules" ref="dataForm" label-width="77px" label-position="left"
               style="width: 100%">

        <el-form-item label="企业名称" prop="name">
          <el-input v-model="formData.name" :placeholder="type==constant.BUSINESS_TYPE_CHANGE?'请输入变更前企业名称':'请输入企业名称'"
                    style="width: 100%"/>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" v-if="showCompanyVerify">
          <el-input v-model="formData.phone" placeholder="输入联系人手机号"
                    oninput="if(value.length>11)value=value.slice(0,11)"
                    style="width: 100%" type="number"/>
        </el-form-item>
        <el-form-item label="验证码" prop="verifyCode" v-if="showCompanyVerify">
          <el-input v-model="formData.verifyCode" placeholder="请输入验证码"
                    oninput="if(value.length>4)value=value.slice(0,4)"
                    style="width: 100%" type="number">
            <template slot="append">
              <div class="send-verify-code-btn" @click="sendVerifyCode"> {{
                  isSendVerifyCode ? count + '秒' : '发送验证码'
                }}
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-button type="primary" @click="onVerifyCompanyName" v-if="!showCompanyVerify"
                   style="width: 100%;">校验
        </el-button>
        <el-button type="primary" @click="onVerifyCompanyInfo" v-if="showCompanyVerify" style="width: 100%;">提交
        </el-button>
      </el-form>

    </div>


  </el-dialog>
</template>

<script>
import {smsCodeSend, enterpriseCheckInfo, enterpriseCheckExist} from "@/api/api";
import {checkMobile, encrypt} from "@/utils/util";
import constant from "@/utils/constant";

var validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入电话号码'))
  } else if (!checkMobile(value)) {
    callback(new Error('请输入正确的11位手机号码'))
  } else {
    callback()
  }
}
export default {
  name: "ChangeApplyNoticeDialog",
  data: function () {
    return {
      constant: constant,
      type: constant.BUSINESS_TYPE_CHANGE,
      showCompanyVerify: false,
      visible: false,
      formData: {
        name: '',
        phone: '',
        verifyCode: '',
      },
      isSendVerifyCode: false,
      timer: null,
      count: 60,
      rules: {
        name: [
          {required: true, message: '请输入企业名称', trigger: 'change'},
        ],
        phone: [
          {required: true, validator: validPhone, trigger: 'change'},
        ],
        verifyCode: [
          {required: true, message: '请输入验证码', trigger: 'change'},
        ],
      }
    }
  },
  methods: {
    init(type) {
      this.type = type
      this.visible = true
      this.showCompanyVerify = false
      this.isSendVerifyCode = false
      this.formData.name = ''
      this.formData.phone = ''
      this.formData.verifyCode = ''
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    sendVerifyCode() {
      if (this.isSendVerifyCode == true) {
        return;
      }
      if (!checkMobile(this.formData.phone)) {
        this.$message.error("请先输入手机号码")
        return
      }
      let _this = this
      _this.isSendVerifyCode = true;
      smsCodeSend(this.formData.phone).then(res => {
        if (res.code == 0) {
          _this.$message.success('验证码已发送')
          const TIME_COUNT = 60;
          if (!_this.timer) {
            _this.count = TIME_COUNT;
            _this.timer = setInterval(() => {
              if (_this.count > 0 && _this.count <= TIME_COUNT) {
                _this.count--;
              } else {
                _this.isSendVerifyCode = false;
                clearInterval(this.timer);
                _this.timer = null;
              }
            }, 1000)
          }
        } else {
          _this.isSendVerifyCode = false;
          this.$message({
            message: '发送验证码失败:' + res.msg,
            type: 'error',
            offset: 300
          })
        }
      })
    },
    onVerifyCompanyName() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          enterpriseCheckExist(this.formData.name).then(res => {
            if (res.code == 0) {
              if (res.data) {
                //	查询到公司，展示校验信息的界面
                this.showCompanyVerify = true;
              } else {
                let content = '';
                if (this.type == constant.BUSINESS_TYPE_CHANGE) {
                  content = '系统中未查询到该企业信息，如是在功能区内注册的企业，请点击确定，并填写企业信息进行工商变更申请'
                  //	未查询到，直接进入信息填写页，不回填数据
                  this.$confirm(content, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal: false
                  }).then(() => {
                    this.jumpToChangeApply(null, this.formData.name)
                  }).catch(() => {
                  });
                } else if (this.type == constant.BUSINESS_TYPE_PROOF_OF_USE) {
                  content = '系统中未查询到该企业信息，请联系楼宇方核实'
                  this.$alert(content, '温馨提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      // this.visible = false;
                    }
                  });
                }
              }
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }

          })

        } else {

        }
      })
    },
    onVerifyCompanyInfo() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const timestamp = Date.now();
          enterpriseCheckInfo(this.formData.phone, this.formData.verifyCode, this.formData.name, timestamp).then(res => {
            if (res.code == 0) {
              if (this.doubleCheck(res.verifyCode, this.formData.phone, this.formData.verifyCode, timestamp)) {
                let enterpriseId = res.data
                if (this.type == constant.BUSINESS_TYPE_CHANGE) {
                  this.jumpToChangeApply(enterpriseId, null)
                } else if (this.type == constant.BUSINESS_TYPE_PROOF_OF_USE) {
                  this.jumpToProofForUseApply(enterpriseId)
                }
              }
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {

        }
      })
    },
    doubleCheck(verifyStr, phone, verifyCode, timestamp) {
      let localVerifyStr = encrypt(phone, verifyCode, timestamp)
      if (localVerifyStr === verifyStr) {
        return true
      } else {
        this.$message({
          message: '本地加密校验失败，请联系管理员',
          type: 'error',
          offset: 300
        })
        return false
      }
    },
    jumpToChangeApply(enterpriseId, companyName) {
      if (enterpriseId == null) {
        enterpriseId = '0'
      }
      if (companyName == null) {
        companyName = '0'
      }
      this.$router.push({
        name: 'ChangeApply',
        params: {
          id: '0',
          enterpriseId: enterpriseId,
          companyName: companyName,
        }
      });
      this.visible = false;
    },
    jumpToProofForUseApply(enterpriseId) {
      if (enterpriseId == null) {
        enterpriseId = '0'
      }
      this.$router.push({
        name: 'ProofForUseApply',
        params: {
          enterpriseId: enterpriseId,
          applyId: 0,
        }
      });
      this.visible = false;
    },
  }
}
</script>

<style scoped>
.form-container {
  margin-top: 50px;
  border-radius: 15px;
  border: 1px solid rgba(206, 206, 206, 1);
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 13px 17px 0px rgba(0, 0, 0, 0.1);
  width: 60%;
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}
</style>
